const CryptoJS = require('crypto-js/sha1');

const generateId = function() {
    return '' + CryptoJS(location.pathname +
            new Date() +
            Math.floor(Math.random() * 100000));
};

module.exports = {
    generateId: generateId
};



// WEBPACK FOOTER //
// ./common/util.js